export function PriceMatrixSettingsCtrl ($scope, inheritorApi, matrices) {
  $scope.matrices = matrices;

  inheritorApi.inheritCtrl('PriceMatrixSettingsLiteCtrl', $scope);
}